import { useMemo, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { ContextErrors, UpdateVariableContextValue } from './types';

export const defaultError: ContextErrors = {
  chosenVariable: {
    hasError: false,
    message: undefined,
  },
};

export const useErrors = (
  values: UpdateVariableContextValue,
  onChange: (values: any) => void,
  model: any
) => {
  const { t } = useTranslation();

  const isChosenVariableInvalid = values?.chosenVariable?.deleted;

  const errors: ContextErrors = useMemo(() => {
    return {
      chosenVariable: {
        hasError: !!isChosenVariableInvalid,
        message: t('Please select a valid variable'),
      },
    };
  }, [isChosenVariableInvalid, t]);

  const errorsRef = useRef<ContextErrors>(errors);

  if (errorsRef.current !== errors) {
    onChange({
      ...values,
      errors,
    });

    errorsRef.current = errors;
  }

  return errors;
};
